/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Author from './Author/index'
import Content from './Content/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content/TreatmentNoteRow/Content",
  innerRef
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsOrange100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.100'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-3-Z1Yf8zk': dtColorsOrange100}}
 className={`views-block ${styles.Horizontal}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<div
  data-testid="Content1.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pb-4-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Author
  viewPath={`${viewPath}/Author`}
/>
</div>
</div>
{children}
</React.Fragment>)
}